import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { BeneficiaryStatus } from '../types';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'search',
    label: 'Name',
  },
  {
    name: 'countContracts',
    label: 'N. of contracts',
  },
  {
    name: 'paymentType',
    label: 'Transfer type',
  },
  {
    name: 'iban',
    label: 'Account number',
  },
  {
    name: 'beneficiaryType',
    label: 'Type',
  },
  {
    name: 'status',
    label: 'Status',
  },
];

export const columnsLabels = {
  search: 'Name',
  status: 'Status',
};

export const schema = {
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const defaultSorter = {};

export const filtersSchema = [
  {
    name: 'search',
    type: FilterType.TEXT,
    placeholder: 'Search by first name...',
  },
  {
    name: 'status',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'status',
        title: 'Approved',
        value: BeneficiaryStatus.APPROVED,
      },
      {
        name: 'status',
        title: 'Draft',
        value: BeneficiaryStatus.DRAFT,
      },
      {
        name: 'status',
        title: 'Rejected',
        value: BeneficiaryStatus.REJECTED,
      },
      {
        name: 'status',
        title: 'Under Review',
        value: BeneficiaryStatus.UNDER_REVIEW,
      },
    ],
  },
];
